import { action, makeObservable, observable } from 'mobx';

import { Loadable } from '../traits/Loadable';

export class WizardStore extends Loadable {
  constructor() {
    super();
    makeObservable(this);
  }

  public initialStep: number | null = null;

  public previousStep: number | null = null;

  @observable
  public step: number = 0;
  @observable
  public height: number = 0;

  @action
  public nextStep = (): void => {
    this.previousStep = this.step;
    this.step = this.step + 1;
  };

  @action
  public prevStep = (): void => {
    this.previousStep = this.step;
    this.step = this.step - 1;
  };

  @action
  public forceStep = (step: number): void => {
    this.step = step;
  };

  @action
  public setHeight = (height: number): void => {
    this.height = height;
  };

  @action
  public setPreviousStep = (step: number): void => {
    this.previousStep = step;
  };

  public goToStep = (step: number): void => {
    this.setPreviousStep(this.step);
    this.forceStep(step);
  };
}
